import axios from "axios";
import baseUrl from "../Api";
import { toast } from "react-toastify";

// Member portal APIs. These take no member id: the backend resolves the member
// from the token, so a member can only ever read their own data.

function header() {
  return {
    Authorization: "Bearer " + localStorage.getItem("token"),
    "Content-Type": "application/json",
  };
}

export async function memberMenu() {
  try {
    return await axios
      .get(`${baseUrl}/member/menu`, { headers: header() })
      .then((response) => response.data)
      .catch((error) => membererror(error));
  } catch (error) {
    membererror(error);
  }
}

export async function memberProfile() {
  try {
    return await axios
      .get(`${baseUrl}/member/profile`, { headers: header() })
      .then((response) => response.data)
      .catch((error) => membererror(error));
  } catch (error) {
    membererror(error);
  }
}

export async function memberLoans() {
  try {
    return await axios
      .get(`${baseUrl}/member/loans`, { headers: header() })
      .then((response) => response.data)
      .catch((error) => membererror(error));
  } catch (error) {
    membererror(error);
  }
}

export async function memberOutstanding() {
  try {
    return await axios
      .get(`${baseUrl}/member/outstanding`, { headers: header() })
      .then((response) => response.data)
      .catch((error) => membererror(error));
  } catch (error) {
    membererror(error);
  }
}

function membererror(error) {
  const status = error?.response?.status;

  if (status === 401) {
    localStorage.clear();
    window.location.hash = "#/login";
    window.location.reload();
  } else if (status === 403) {
    toast.error("You do not have access to this page.");
  } else {
    toast.error(error?.message || "Something went wrong.");
  }
}
